import React, { useEffect } from 'react';
import { Typography } from '@mui/material';
import StyledMarkdown from '../../common/components/StyledMarkdown';
import { getChatAttribute } from './ChatMessageAttributes';
import { ChatMessage } from './PromptChatAdapter';
import ChatHtmlContent from './ChatHtmlContent';
import ChatHtmlFileContent, { ChatHtmlResolver } from './ChatHtmlFileContent';
import { AttachmentUrlResolver } from './ChatAttachmentPreview';

export default function ChatMessageContent({ message, resolveHtml, resolveAttachmentUrl }: {
	message: ChatMessage;
	resolveHtml?: ChatHtmlResolver;
	resolveAttachmentUrl?: AttachmentUrlResolver;
}) {
	const contents = message.contents ?? [{
		id: message.id,
		text: message.text,
		contentType: getChatAttribute(message.attributes, 'ContentType') ?? message.contentType,
	}];
	useEffect(() => {
		for (const content of message.contents ?? []) {
			const type = content.contentType.trim().toLowerCase();
			if (message.role !== 'user' && content.fileId && (type === 'sandboxed-html-v1' || type === 'html')) {
				console.info('[ChatMessageContent HTML trace] file attachment routed to preview', {
					messageId: message.id,
					contentId: content.id,
					contentType: type,
					fileId: content.fileId,
					hasHtmlResolver: Boolean(resolveHtml),
					hasDownloadResolver: Boolean(resolveAttachmentUrl),
				});
			}
		}
	}, [message.contents, message.id, message.role, resolveAttachmentUrl, resolveHtml]);
	return <>{contents.map((content) => {
		const type = content.contentType.trim().toLowerCase();
		if (message.role !== 'user' && content.fileId && (type === 'sandboxed-html-v1' || type === 'html')) {
			return <ChatHtmlFileContent key={content.id} fileId={content.fileId} fileName={content.fileName} scripts={type === 'sandboxed-html-v1'} resolveHtml={resolveHtml} resolveAttachmentUrl={resolveAttachmentUrl} />;
		}
		if (!content.text) return null;
		if (message.role !== 'user') {
			if (type === 'sandboxed-html-v1' || type === 'html') {
				return <ChatHtmlContent key={content.id} html={content.text} scripts={type === 'sandboxed-html-v1'} fileName={content.fileName} />;
			}
			if (type === 'markdown' || type === 'text/markdown') {
				return <StyledMarkdown key={content.id}>{content.text}</StyledMarkdown>;
			}
		}
		return <Typography key={content.id} variant="body2" sx={{ whiteSpace: 'pre-wrap', fontSize: 'inherit', wordBreak: 'break-word' }}>{content.text}</Typography>;
	})}</>;
}
